import { render, staticRenderFns } from "./_tabCategorySection.vue?vue&type=template&id=33874c8c&scoped=true&"
import script from "./_tabCategorySection.vue?vue&type=script&lang=js&"
export * from "./_tabCategorySection.vue?vue&type=script&lang=js&"
import style0 from "./_tabCategorySection.vue?vue&type=style&index=0&id=33874c8c&prod&scoped=true&lang=css&"
import style1 from "./_tabCategorySection.vue?vue&type=style&index=1&id=33874c8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33874c8c",
  null
  
)

export default component.exports